/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState } from 'react'
import Sidebar from './sidebar'
import {HiMenu} from 'react-icons/hi'


import './style.css'
const ComponentScreen = (Component) => () => {
  const [showSidebar, setShowSidebar] = useState(false);

  const toggleSidebar = () =>{
    console.log("hello")
    setShowSidebar(!showSidebar);
  }
  return (
    <div className='hoc'>
        {/* header */}
        <div className='hoc-header' >
            <div className='toggle-sidebar' onClick={toggleSidebar}><HiMenu onClick={toggleSidebar} /></div>
            <span className='logo'>AUI</span>
        </div>
        <div className='hoc-main'>
            <Sidebar showSidebar={showSidebar}/>
            <div className='hoc-children'>
                <Component />
            </div>
        </div>
    </div>
  )
}

export default ComponentScreen